import { any, bool, node, number, oneOfType, string } from 'prop-types';
import React, { Children, useEffect, useState } from 'react';
import AiOutlineMinus from '../icons/AiOutlineMinus';
import AiOutlinePlus from '../icons/AiOutlinePlus';

export default function SearchPageSidebarSection({ isMobile, headingText, children, itemCount,
    skeletonMode }) {
    const [expanded, setExpanded] = useState(!isMobile);
    const childrenCount = !skeletonMode ? (itemCount || Children.count(children)) : itemCount;
    useEffect(() => {
        setExpanded(!isMobile);
    }, [isMobile]);
    return (<div
        className={'search-sidebar--section mb-3'}
        style={{ ...expanded === false && ({ paddingBottom: '0',
            marginBottom: '0' }) }}>
        {headingText && (<span
            className={'search-sidebar--heading'}
            style={{ ...expanded === false && ({ marginBottom: '6px' }) }}
            onClick={() => setExpanded(!expanded)}>
            {headingText}
            {expanded === false && (<AiOutlinePlus
                size={'20px'} />)}
            {expanded === true && (<AiOutlineMinus
                size={'20px'} />)}
        </span>)}
        {skeletonMode === true && (<span
            className={'search-sidebar--heading skeleton'}
            style={{ ...expanded === false && ({ marginBottom: '6px' }) }} />)}
        <div
            className={`search-sidebar--section-inner${skeletonMode === true ? ' skeleton' : ''}`}
            style={{ maxHeight: expanded === true ? `${Math.max(childrenCount * 30, 250)}px` : '0' }}>
            {children}
            {skeletonMode === true && (<>
                {new Array(childrenCount).fill(0).map((_v, idx) => (<div
                    key={idx}
                    className={'skeleton-item'}></div>))}
            </>)}
        </div>
    </div>);
}

SearchPageSidebarSection.propTypes = {
    isMobile: bool,
    headingText: any,
    children: node,
    itemCount: oneOfType([number, string]),
    skeletonMode: bool,
};

SearchPageSidebarSection.defaultProps = {
    skeletonMode: false,
};